<template>
  <div id="engine">
    <div class="engineHead">
      <home-header :navName="navName"></home-header>
      <div id="engineList">
        <div class="engineList_cell">
          <div class="list_item" v-for="(item,index) of engineList" :key="index">
              <div class="list_cloumContent">
                <div class="title">{{item.title}}</div>
                <div class="treeContent">
                  <ul>
                    <li v-for="(treeitem,treeindex) of item.son_tree"
                        :key="treeindex"
                        @click="showInfos(treeitem.gcms_id,item.name)"
                    >
                    {{treeitem.gcms_title}}
                    </li>
                  </ul>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="nav_name">平台</div>
      <div class="nav_name_info">
        <p>贴近客户业务需求，支持深度定制，提供全面的Web API和Android API二次开发接口。</p>
      </div>
    </div>

  	<div id="bodyer">
  		<div class="location">
        当前位置：平台 > <span class="type">分类</span> > <span class="serve">{{infosData.gcms_title}}</span>
        <span class="right">
          <img src="../../assets/images/engine/search.png" alt="">
          <input type="text" placeholder="搜索">
        </span>

      </div>
      <div class="introduce">介绍</div>
      <div v-html="infosData.content" class="infosContent"></div>
  	</div>
    <connect-part></connect-part>
    <home-footer></home-footer>
  </div>
</template>
<script>
import axios from 'axios'
import HomeHeader from './header'
import ConnectPart from './connect'
import HomeFooter from './footer'
export default {
  name: 'facilityCloud',
  components:{
  	HomeHeader:HomeHeader,
    ConnectPart:ConnectPart,
    HomeFooter:HomeFooter
  },
  data: function() {
  		return {
  			listdata:"",
  			navName:"engine",
        engineList:[],
        getIndex:0,
        infosData:{}
  		}
  },
  methods:{
  	getGcmsList:function(){
      axios.get(xdc_app_config.gcms_server+'/menumanage').then(this.updateData);
  	},
  	updateData:function(res){
      var curdata = res.data.data;
      for(var i=0;i<curdata.length;i++){
        if(curdata[i].name == 'engine'){
          this.eachData(curdata[i].son_tree);
          return false;
        }
      }
  	},
    eachData:function(data){
      var _this = this;
      $.each(data,function(i,t){
        _this.buildCloum(t);
      })
      _this.getIndex = 0;
      _this.getLoumData();
    },
    buildCloum:function(data){
      var _this = this;
      if(data.son_tree){
        $.each(data.son_tree,function(i,t){
          _this.buildCloum(t);
        })
      }else{
        var item = {
          name:data.name,
          title:data.title,
          son_tree:[]
        }
        _this.engineList.push(item)
      }
    },
    getLoumData:function(){
      if(this.engineList[this.getIndex]){
        var cloumName = this.engineList[this.getIndex].name;
        axios.get(xdc_app_config.gcms_server+'/content/'+cloumName).then(this.updataCloum);
      }else{
        return false;
      }
    },
    updataCloum:function(res){
      this.engineList[this.getIndex].son_tree = res.data.data;
      this.getIndex++;
      this.getLoumData();
    },
    showInfos:function(id,name){
      //console.log(id,name)
      axios.get(xdc_app_config.gcms_server+'/content/'+name+'/'+id).then(this.updataInfosData);
    },
    updataInfosData:function(res){
      console.log(res);
      this.infosData = res.data.data;
    }
  },
  mounted:function(){
  	this.getGcmsList();
    this.showInfos(1,"engine_storage")
  },
  updated:function(){
    $(".engine").bind('mouseover',function(){
      $("#engineList").show();
    })
    $("#engineList").bind('mouseleave',function(){
      $("#engineList").hide();
    })
    var arry = $('.infosContent').find('img');
    for(var i=0;i< arry.length;i++){
      var src = arry.eq(i).attr('src');
      if(src){
        $(arry.eq(i)).attr('src',src);
      }
    }
  }
}
/*$(".engine").bind('onmouseover',function(){
  $("#engineList").show();
})*/
</script>
<style scoped>
@import "../../assets/styles/engine.css";
</style>



// WEBPACK FOOTER //
// src/pages/components/engine.vue